module.exports = __webpack_public_path__ + "static/fb_white-ba514d4a0d1a9a99d2ee414b93d185e9.png";